// services/cameraMonitorApi.js
import axios from 'axios';

const API_BASE =
  (process.env.REACT_APP_BACKEND_URL && process.env.REACT_APP_BACKEND_URL.replace(/\/+$/, '')) ||
  'http://localhost:4000';

export async function fetchCameraMonitor(baseUrl, cameraPath) {
  try {
    const url = `${baseUrl}/${cameraPath}/rtmp-monitor.json`;
    const response = await axios.get(url);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Error fetching camera monitor:', error);
    return { success: false, error: error.message };
  }
}

export async function fetchCameraHistory(baseUrl, cameraPath) {
  try {
    const url = `${baseUrl}/${cameraPath}/rtmp-history.json`;
    const response = await axios.get(url);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Error fetching camera history:', error);
    return { success: false, error: error.message };
  }
}

export async function fetchCameraMonitorFromInstance(instanceId) {
  try {
    const url = `${API_BASE}/event-wizard/proxy/${instanceId}/rtmp-monitor`;
    const response = await axios.get(url, {
      headers: { 'auth-token': localStorage.getItem('auth-token') },
    });
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Error fetching monitor from instance:', error);
    return { success: false, error: error.message };
  }
}

export function buildCameraUrls(baseUrl, cameraPath) {
  return {
    mpd: `${baseUrl}/${cameraPath}/cam.mpd`,
    monitor: `${baseUrl}/${cameraPath}/rtmp-monitor.json`,
    history: `${baseUrl}/${cameraPath}/rtmp-history.json`,
  };
}
